import { Form } from 'antd';
import { useContext } from 'react';

import { LimitedEdition } from 'app/components/commons/Package/LimitedEdition/LimitedEdition';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useHotels } from 'app/hooks/data/hotels/useHotel';
import { useCountries } from 'app/hooks/data/useCountries';
import type { OpeningHours } from 'app/typings/core/admin/packs/openingHours/openingHours';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import './General.scss';
import { BasicInformations } from './_components/BasicInformations';
import { Naming } from './_components/Naming';
import { OpeningHoursComponent } from './_components/OpeningHours';

export const General = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance<
    Partial<PackResponse> & {
      isDaytime: boolean;
      aliasForUser: string;
      openingHours: OpeningHours;
    }
  >();
  const formValues = Form.useWatch([], form);
  const { data: hotels } = useHotels();
  const { data: countries } = useCountries();

  if (!hotels) {
    return null;
  }

  const showNamingCard = !!formValues?.hotelId;
  const showOpeningHours = formValues?.isDaytime;

  const selectedHotel = hotels.find(
    (hotel) => hotel.id === formValues?.hotelId
  );
  const hotelTimezone = countries?.find(
    (country) => country.id === selectedHotel?.countryId
  )?.timezone;

  return (
    <>
      <BasicInformations />
      {showNamingCard && <Naming />}
      {showOpeningHours && <OpeningHoursComponent />}
      <LimitedEdition disabled={!isEditMode} timezone={hotelTimezone} />
    </>
  );
};
